import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
type IconComponent = React.ComponentType<{
  className?: string;
}>;
type Props = {
  icon: IconComponent;
  title: string;
  description?: string;
  selected?: boolean;
  soon?: boolean;
  soonLabel?: string;
} & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "title">;
export function SelectableIconTile({
  icon: Icon,
  title,
  description,
  selected,
  soon,
  soonLabel,
  className,
  ...props
}: Props) {
  if (soon) {
    return <div aria-disabled className={cn("relative flex flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-muted p-5 opacity-60 cursor-not-allowed", className)}>
        {soonLabel && <Badge variant="outline" size="sm" className="absolute top-2 right-2">
            {soonLabel}
          </Badge>}
        <Icon className="h-7 w-7 text-muted-foreground" />
        <span className="font-semibold text-sm text-muted-foreground">
          {title}
        </span>
        {description && <span className="text-xs text-center text-muted-foreground">
            {description}
          </span>}
      </div>;
  }
  return <button type="button" aria-pressed={selected} className={cn("flex flex-col items-center justify-center gap-2 rounded-xl border-2 p-5 transition-all cursor-pointer", selected ? "border-primary bg-primary/10" : "border-muted bg-primary/5 hover:bg-primary/10 hover:border-primary/40", className)} {...props} data-sentry-component="SelectableIconTile" data-sentry-source-file="SelectableIconTile.tsx">
      <Icon className="h-7 w-7 text-primary" data-sentry-element="Icon" data-sentry-source-file="SelectableIconTile.tsx" />
      <span className="font-semibold text-sm text-center">{title}</span>
      {description && <span className="text-xs text-center text-muted-foreground">
          {description}
        </span>}
    </button>;
}